module.exports = "/static/js/527ffb500c35f127f37c807713ce69f6.png";